/* unplugin-vue-components disabled */import { render } from "./NotificationParameters.vue?vue&type=template&id=2db3d1ba&scoped=true&ts=true"
import script from "./NotificationParameters.vue?vue&type=script&lang=ts"
export * from "./NotificationParameters.vue?vue&type=script&lang=ts"

import "./NotificationParameters.vue?vue&type=style&index=0&id=2db3d1ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db3d1ba"]])

export default __exports__